module.exports = __webpack_public_path__ + "static/media/musician.1dc5865d.jpg";